import dayjs from 'dayjs';

export default function(value) {
    /**
     * Formats a date
     * Example: 1590413840 => 06/29/2020
     * @param {String} value
     * @return {String}
     */
    if (!value) {
        return null;
    }

    return dayjs.unix(value).format('MM/DD/YYYY');
}
